import { Component, Input, OnInit } from '@angular/core';
import { PulseItem } from '../../models/sell.models';
import { MarketPulseService } from '../../../../services/market-pulse.service';
import {
  MarketPulseActivityItem,
  MarketPulseResponse,
} from '../../../../models/market-pulse.model';

const DEFAULT_PULSE_ITEMS: PulseItem[] = [
  { when: '2h', text: 'HSS 23 observed sold' },
  { when: '14m', text: 'someone searched \u201CSINGH\u201D' },
  { when: '1d', text: 'A25 ETO observed sold' },
  { when: '3h', text: 'dealer clicked through to MX09 DAV' },
  { when: '2d', text: 'DR09 ZEE sold via DVLA' },
  { when: 'today', text: 'AB25 TOM newly listed' },
];

const MAX_LIVE_ITEMS = 8;

@Component({
  selector: 'pla-plate-x-pulse-rail',
  templateUrl: './plate-x-pulse-rail.component.html',
  styleUrls: ['./plate-x-pulse-rail.component.scss'],
})
export class PlateXPulseRailComponent implements OnInit {
  @Input() items: PulseItem[] = DEFAULT_PULSE_ITEMS;
  @Input() label: string = 'Market';
  @Input() ariaLabel: string = 'Observed market activity';
  /** When true, render the supplied items verbatim and skip the live MarketPulse fetch. */
  @Input() externalItems: boolean = false;

  constructor(private marketPulse: MarketPulseService) {}

  ngOnInit(): void {
    if (this.externalItems) return;
    this.marketPulse.getMarketPulse().subscribe((res) => {
      const live = this.toPulseItems(res);
      if (live.length > 0) this.items = live;
    });
  }

  get doubledItems(): PulseItem[] {
    return [...this.items, ...this.items];
  }

  private toPulseItems(res: MarketPulseResponse | null): PulseItem[] {
    if (!res || !res.activity || res.activity.length === 0) return [];
    return [...res.activity]
      .sort((a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime())
      .slice(0, MAX_LIVE_ITEMS)
      .map((item) => ({
        when: relativeWhen(item.eventDate),
        text: describeActivity(item),
      }));
  }
}

function describeActivity(item: MarketPulseActivityItem): string {
  const plate = item.formattedRegistration || item.registration || '';
  switch (item.type) {
    case 'sold':     return `${plate} observed sold`;
    case 'listed':   return `${plate} newly listed`;
    case 'viewed':   return `dealer clicked through to ${plate}`;
    case 'searched': return item.term ? `someone searched \u201C${item.term}\u201D` : `search activity on ${plate}`;
    default:         return plate;
  }
}

function relativeWhen(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return 'recent';
  const diffMin = Math.max(0, Math.round((Date.now() - then) / 60000));
  if (diffMin < 1)   return 'just now';
  if (diffMin < 60)  return `${diffMin}m`;
  const diffH = Math.round(diffMin / 60);
  if (diffH < 24)    return `${diffH}h`;
  const diffD = Math.round(diffH / 24);
  return `${diffD}d`;
}
